import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rde-no-business-near-you',
  templateUrl: './no-business-near-you.component.html',
  styleUrls: ['./no-business-near-you.component.scss']
})
export class NoBusinessNearYouComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
